<!-- Filter Tabs -->
<div class="filter-tabs">
  <button
    class="filter-btn"
    [class.active]="filter === 'pending'"
    (click)="loadReminders('pending')"
    [disabled]="loading">
    Pending
  </button>
  <button
    class="filter-btn"
    [class.active]="filter === 'upcoming'"
    (click)="loadReminders('upcoming')"
    [disabled]="loading">
    Upcoming
  </button>
  <button
    class="filter-btn"
    [class.active]="filter === 'dismissed'"
    (click)="loadReminders('dismissed')"
    [disabled]="loading">
    Done
  </button>
  <button
    *ngIf="filter !== 'dismissed' && selectedIds.size > 0"
    class="bulk-dismiss-btn"
    (click)="bulkDismiss()"
    [disabled]="bulkDismissing"
    title="Dismiss selected">
    <i class="fas" [ngClass]="bulkDismissing ? 'fa-spinner fa-spin' : 'fa-check-double'"></i>
    Dismiss ({{ selectedIds.size }})
  </button>
  <button class="refresh-btn" (click)="loadReminders()" [disabled]="loading" title="Refresh">
    <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
  </button>
</div>

<!-- Select All Header -->
<div class="select-all-row" *ngIf="filter !== 'dismissed' && reminders.length > 0">
  <label class="checkbox-wrapper" (click)="toggleSelectAll($event)">
    <input type="checkbox" [checked]="allSelected" />
    <span class="select-all-label">Select All</span>
  </label>
</div>

<!-- Reminder List -->
<div class="reminder-list">
  <div
    *ngFor="let reminder of reminders"
    class="reminder-row"
    [class.selected]="isSelected(reminder)"
    [title]="reminder.tooltip"
    (click)="openReminder(reminder)">
    <div class="reminder-checkbox" *ngIf="filter !== 'dismissed'" (click)="toggleSelection(reminder, $event)">
      <input type="checkbox" [checked]="isSelected(reminder)" />
    </div>
    <div class="reminder-date">
      <span *ngIf="!reminder.rrule">{{ reminder.start_date_str }}</span>
      <span *ngIf="reminder.rrule" [class.text-danger]="!reminder.next_date_str">
        {{ reminder.next_date_str || 'Ended' }}
        <i class="fas fa-redo-alt fa-xs text-info" title="Recurring"></i>
      </span>
    </div>
    <div class="reminder-info">
      <div class="reminder-title">{{ reminder.title_short }}</div>
      <div class="reminder-topic">{{ reminder.topic_short }}</div>
    </div>
    <div class="reminder-actions" *ngIf="filter !== 'dismissed'">
      <button
        class="dismiss-btn"
        (click)="dismiss(reminder, $event)"
        [disabled]="reminder.dismissing"
        title="Dismiss">
        <i class="fas" [ngClass]="reminder.dismissing ? 'fa-spinner fa-spin' : 'fa-check'"></i>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && reminders.length === 0" class="empty-state">
    <i class="fas fa-bell-slash"></i>
    <span *ngIf="!loadError">No {{ filter }} reminders</span>
    <span *ngIf="loadError">Reminders did not load</span>
    <button *ngIf="loadError" class="state-action-btn" type="button" (click)="loadReminders()">
      Retry
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-state">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</div>

<!-- Reminder Detail Modal -->
<ng-template #reminderModal>
  <div class="modal-header">
    <h5 class="modal-title">Reminder Details</h5>
    <button type="button" class="close" (click)="modalRef.hide()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="selectedReminder">
    <table class="table table-sm">
      <tr>
        <th style="width: 120px">For</th>
        <td>
          <a href="javascript:void(0)" (click)="goToReminderable(selectedReminder)">
            {{ selectedReminder.reminderable_title }}
          </a>
        </td>
      </tr>
      <tr *ngIf="selectedReminder.matter_number && selectedReminder.matter_id">
        <th>Matter</th>
        <td>
          <a [routerLink]="'/matters/' + selectedReminder.matter_id">{{ selectedReminder.matter_number }}</a>
          <span *ngIf="selectedReminder.matter_name"> - {{ selectedReminder.matter_name }}</span>
        </td>
      </tr>
      <tr>
        <th>When</th>
        <td>
          <span *ngIf="!selectedReminder.rrule">{{ selectedReminder.start_date_str }} {{ selectedReminder.start_time_str }}</span>
          <span *ngIf="selectedReminder.rrule">
            {{ selectedReminder.next_date_str || 'Ended' }} {{ selectedReminder.next_time_str }}
            <span class="text-muted">({{ selectedReminder.rrule_text }})</span>
          </span>
        </td>
      </tr>
      <tr *ngIf="selectedReminder.topic">
        <th>Topic</th>
        <td>{{ selectedReminder.topic }}</td>
      </tr>
      <tr *ngIf="selectedReminder.body">
        <th>Notes</th>
        <td style="white-space: pre-wrap">{{ selectedReminder.body }}</td>
      </tr>
      <tr *ngIf="selectedReminder.delivery_methods?.length">
        <th>Notify via</th>
        <td>
          <span *ngFor="let m of selectedReminder.delivery_methods" class="badge badge-secondary mr-1">{{ m }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="modalRef.hide()">Close</button>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      *ngIf="selectedReminder"
      (click)="editReminder(selectedReminder)">
      <i class="fas fa-edit"></i> Edit
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      *ngIf="filter !== 'dismissed' && selectedReminder && !selectedReminder.opened"
      (click)="dismiss(selectedReminder, $event); modalRef.hide()">
      <i class="fas fa-check"></i> Dismiss
    </button>
  </div>
</ng-template>
